import React from 'react';

// Perfectly symmetrical Tiwaz
export const TiwazIcon = ({ size = 24, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M12 22 L12 2 M12 2 L19 9 M12 2 L5 9"/>
  </svg>
);

// Perfectly symmetrical crossed-leg Othala
export const OthalaIcon = ({ size = 24, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M 5 23 L 19 9 L 12 2 L 5 9 L 19 23" />
  </svg>
);

// Interlaced Norse wave divider
export const KnotworkDivider = () => (
  <div 
    className="w-full h-4 opacity-20 my-6 bg-repeat-x" 
    style={{ 
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 20' fill='none' stroke='%233F5D44' stroke-width='2'%3E%3Cpath d='M0 10 Q 10 0, 20 10 T 40 10 M0 10 Q 10 20, 20 10 T 40 10'/%3E%3C/svg%3E\")" 
    }} 
  />
);
